import * as PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import CustomQuillEditor from '../customQuill';
import { updatePTagsAndReturnHTML } from '../../utils/quillUtils';
import { useTranslate } from '@tolgee/react';
import MessageTemplateCard from '../../../whatsappTemplateBuilder/templateCardForMessage';
import { ADDITIONAL_DATA_TYPE_WHATSAPP_TEMPLATE } from '../../constants';

export default function MessageText({
  messageContent,
  left,
  editMessage,
  setMessageContent,
  isInternalNote,
  setMsg,
  msgDelta,
  locationUUID,
  hasError,
  additional_data
}) {
  const { t } = useTranslate();

  const [quillEditor, setQuillEditor] = useState(null);

  const [showWhatsappTemplate, setShowWhatsappTemplate] = useState(false);

  useEffect(() => {
    if (!quillEditor) return;
    quillEditor?.on('text-change', function (delta, oldDelta, source) {
      if (source == 'api') {
        console.log('An API call triggered this change.');
      } else if (source == 'user') {
        console.log('A user action triggered this change.');
        setMsg(quillEditor.getContents());
        setMessageContent({
          text: updatePTagsAndReturnHTML(quillEditor.root),
          status: 'message'
        });
      }
    });
  }, [quillEditor]);

  useEffect(() => {
    if (additional_data) {
      if (additional_data.type === ADDITIONAL_DATA_TYPE_WHATSAPP_TEMPLATE) {
        setShowWhatsappTemplate(true);
      }
    }
  }, []);

  function ensureAnchorTargets(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const anchors = doc.querySelectorAll('a');
    anchors.forEach((a) => {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });

    return doc.body.innerHTML;
  }

  return editMessage ? (
    <CustomQuillEditor
      quillEditor={quillEditor}
      setQuillEditor={setQuillEditor}
      readOnly={false}
      locationUUID={locationUUID}
      messageSettings={{}}
      msg={msgDelta}
      setMsg={setMsg}
      editorStyle={{ fontSize: '14px', width: 400, borderRadius: 0 }}
      activeMention={isInternalNote}
    />
  ) : (
    <>
      {!showWhatsappTemplate && (
        <div
          className={`${
            messageContent.status === 'empty' ? 'text-muted' : 'text-dark'
          } fw-semibold mw-lg-400px text-start`}
          style={{
            whiteSpace: 'pre-line', // Use pre-line to break lines
            overflowWrap: 'break-word',
            width: 400
          }}
          dangerouslySetInnerHTML={{
            __html: ensureAnchorTargets(messageContent.text)
          }}
        />
      )}

      {showWhatsappTemplate && (
        <div className="w-100 d-flex justify-content-end">
          <MessageTemplateCard data={additional_data?.data} />
        </div>
      )}
      {hasError && (
        <div className="text-danger text-start">
          <span className="mt-2">
            {t('communication.messageText.hasErrorMessage')}
          </span>
        </div>
      )}
    </>
  );
}
MessageText.propTypes = {
  messageContent: PropTypes.any,
  left: PropTypes.bool.isRequired,
  editMessage: PropTypes.bool.isRequired,
  setMessageContent: PropTypes.func.isRequired,
  setMsg: PropTypes.func.isRequired,
  msgDelta: PropTypes.any,
  isInternalNote: PropTypes.bool.isRequired,
  locationUUID: PropTypes.string,
  hasError: PropTypes.bool || null
};
